import _ from "lodash";
import { ResendReleasePaymentHoldConstant } from "presentation/constant/ResendReleasePaymentHold/ResendReleasePaymentHoldConstant";
import { useResendReleasePaymentHoldVM } from "presentation/hook/ResendReleasePaymentHold/useResendReleasePaymentHoldVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useResendReleasePaymentHoldTracked } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useMemo } from "react";
import { HPHButton } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const UpdateAgentDeliveryDatePanel = () => {
    const [resendReleasePaymentHoldState] = useResendReleasePaymentHoldTracked();
    const { selectedRows, agentDeliveryDate, allFormState } = resendReleasePaymentHoldState;
    const resendReleasePaymentHoldVM = useResendReleasePaymentHoldVM();
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (agentDeliveryDate && agentDeliveryDate < today) {
            messageBarVM.showError('The Agent delivery date time should not be earlier than the current system date.');
            return;
        }
        resendReleasePaymentHoldVM.onSave(agentDeliveryDate);
    }, [selectedRows, messageBarVM, resendReleasePaymentHoldVM, agentDeliveryDate]);

    const handClose = useCallback(() => {
        resendReleasePaymentHoldVM.onCloseUpdatePanel();
    }, [resendReleasePaymentHoldVM]);

    const memoAgentDeliveryDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={false}
                label={ResendReleasePaymentHoldConstant.AGENT_DELIVERY_DATE}
                width="220px"
                date={agentDeliveryDate}
                fieldName="agentDeliveryDate"
                errorMessage={allFormState?.agentDeliveryDate}
                onDateChange={resendReleasePaymentHoldVM.onFieldChange} />
        </div>
        , [allFormState, agentDeliveryDate, resendReleasePaymentHoldVM])

    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Update Agent Delivery Date"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoAgentDeliveryDate}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(UpdateAgentDeliveryDatePanel);